module.exports = __webpack_public_path__ + "media/images/screens/10_signin-f39c4e6300e9dbe1f4bc45d3fb5c2cd7.jpg";